export default __webpack_public_path__ + "static/media/el1.698fa80d.svg";